import React from 'react'
import Title from 'antd/es/typography/Title'
import { Flex } from 'antd'
import MarkdownRenderer from '../../../../../../../../../components/common/markdown-renderer'

const Guidelines = ({ question }) => {
    return (
        <Flex vertical gap={16}>
            {question?.gradingReferenceContent && (
                <div>
                    <Title level={2} style={{ fontSize: '1rem', margin: 0, marginRight: 8 }}>
                        Grading reference content
                    </Title>
                    <MarkdownRenderer content={question?.gradingReferenceContent} />
                </div>
            )}
        </Flex>
    )
}

export default Guidelines
